// extracted by mini-css-extract-plugin
module.exports = {"bus-station-search":"bus-station-search_bus-station-search__jl72Y","station-search":"bus-station-search_station-search__QweqV","button":"bus-station-search_button__wIlcZ"};